import React, { useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'
import { notification } from 'antd'
import Room from '../components/room'
import { getRooms } from '../utils/helpers'

const Home = () => {
  const isSmall = useMediaQuery({ maxDeviceWidth: 750 })
  const isMobile = useMediaQuery({ maxDeviceWidth: 420 })
  const rooms = getRooms()

  useEffect(() => {
    if (isSmall)
      notification.info({
        message: 'Heads Up!',
        description:
          'This app was not designed for mobile. For the best experience, please switch to desktop.',
        placement: isMobile ? 'topLeft' : 'topRight',
        duration: null,
      })
  }, [isMobile, isSmall])

  return (
    <>
      {rooms.map((room) => (
        <Room key={room} id={room} />
      ))}
    </>
  )
}

export default Home
